import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  useColorModeValue,
  useToast,
  // Select,
} from "@chakra-ui/react";
import Select from "react-select";
import { BiSliderAlt } from "react-icons/bi";
import useUser from "hooks/use-user";
import "./multiSelect.css";

interface AddUserModalProps {}

const AddUserModal: React.FC<AddUserModalProps> = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { getSuppliers, suppliers, postData } = useUser();
  const textTable = useColorModeValue("black", "white");
  const customStyles = {
    option: (provided: any, state: { isSelected: any }) => ({
      ...provided,
      borderBottom: "1px dotted pink",
      color: state.isSelected ? "black" : "black",
      padding: 20,
    }),
  };
  const toast = useToast();

  const [userData, setUserData] = useState({
    name: "",
    email: "",
    password: "",
    accessScheduling: true,
    accessPortal: true,
    suppliersId: "",
    displayNameCalendar: false,
  });

  const [selectSupplier, setSelectSupplier] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const optionsSystem = [
    { label: "  1 - Portal", value: 1 },
    { label: "  2 - Logistica", value: 2 },
  ];

  const handleDinamico = (e: {
    target: { name: any; value: any; type: any; checked: any };
  }) => {
    const { name, value, type, checked } = e.target;

    setUserData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validateEmail = (email: string) => {
    // Use a regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleSubmit = () => {
    if (!validateEmail(userData.email)) {
      toast({
        title: "Error",
        description: "formato do email incorreto",
        status: "warning",
        position: "top",
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    // Lógica para lidar com o envio do formulário
    var accessportal = selectedOptions.findIndex((x) => x.value === 1);
    var accesspscheduling = selectedOptions.findIndex((x) => x.value === 2);
    const idsSuppliers = selectSupplier.map((objeto) => objeto.value);
    const objUser = {
      name: userData.name,
      email: userData.email,
      accessScheduling: accessportal !== -1 ? true : false,
      accessPortal: accesspscheduling !== -1 ? true : false,
      suppliersIds: idsSuppliers,
      displayNameCalendar: userData.displayNameCalendar === true ? true : false,
    };
    postData(objUser);
    handleClose();
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };
  const [decryptedData, setDecryptedData] = useState<string | null>(null);

  useEffect(() => {
    if (suppliers.length === 0 && isOpen) {
      getSuppliers();
    }

    // Exemplo de uso
    // const encryptedData = "Rr3Vjt+hNQANc5tUqpjSNA==";
    // decrypt(encryptedData, true);
  }, [isOpen, suppliers]);

  return (
    <>
      <Button colorScheme="green" variant="outline" onClick={handleOpen}>
        Adicionar
      </Button>
      <Modal isOpen={isOpen} onClose={handleClose} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={"gray.200"}
            background={"#1d5840"}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                Adicionar Usuário
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody>
            <Box maxW={480} flex={{ base: "1", md: "0 0 300px" }} pb={6}>
              <Flex>
                <Box pl={2} pr={2}>
                  <FormLabel fontWeight={700}>Nome</FormLabel>
                  <Input
                    type="text"
                    w={{ base: 330, md: 440 }}
                    color={textTable}
                    name="name"
                    value={userData.name}
                    onChange={handleDinamico}
                  />
                </Box>
              </Flex>
              <Flex>
                <Box pl={2} pr={2} pt={4}>
                  <FormLabel fontWeight={700}>Email</FormLabel>
                  <Input
                    type="text"
                    w={{ base: 330, md: 440 }}
                    name="email"
                    color={textTable}
                    value={userData.email}
                    onChange={handleDinamico}
                  />
                </Box>
              </Flex>
              {/* <Flex>
                <Box pl={2} pr={2} pt={4}>
                  <FormLabel fontWeight={700}>Senha</FormLabel>
                  <Input
                    type="password"
                    isDisabled={true}
                    w={{ base: 330, md: 440 }}
                    color={textTable}
                    name="password"
                    value={userData.password}
                    onChange={handleDinamico}
                  />
                </Box>
              </Flex> */}
            </Box>
            <Box maxW={480} pb={6}>
              <Flex direction={{ base: "column", md: "row" }}>
                <Box pl={2} pr={2} mb={{ base: 4, md: 0 }}>
                  <Select
                    defaultValue={selectSupplier}
                    name="colors"
                    onChange={setSelectSupplier}
                    options={suppliers}
                    color={textTable}
                    placeholder="Selecione os fornecedores..."
                    theme={(theme: { colors: any }) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        text: "#6EB680",
                        font: "#6EB680",
                        primary25: "#6EB680",
                        primary: "#6EB680",
                        neutral80: "black",
                        color: "black",
                      },
                    })}
                    styles={customStyles}
                    isMulti
                    className="custom-select-2"
                    classNamePrefix="select"
                  />
                </Box>
              </Flex>
              <Stack direction="row" align="center" mt={2} ml={2}>
                <Checkbox
                  name="displayNameCalendar"
                  isChecked={userData.displayNameCalendar}
                  onChange={(e) =>
                    handleDinamico({
                      target: {
                        name: "displayNameCalendar",
                        value: e.target.value,
                        type: "checkbox",
                        checked: e.target.checked,
                      },
                    })
                  }
                >
                  Adicionar usuário ao calendário
                </Checkbox>
              </Stack>
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={handleClose}>
              Fechar
            </Button>
            <Button
              colorScheme="green"
              isDisabled={userData.name === "" || userData.email === ""}
              ml={3}
              onClick={handleSubmit}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AddUserModal;
